import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/drama_completions', { params })
}

export const show = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/drama_completions/${id}`, { params })
}

export const reply = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/drama_completions/${id}/reply`, params)
}
